import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Header from './Header'
import Footer from './Footer'

export default function BasicLayout({ children }) {
	return (
		<Block>
			<Header />
			{children}
			<Footer />
		</Block>
	)
}

BasicLayout.propTypes = {
	children: PropTypes.element.isRequired,
}

const Block = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`
